export enum Widget {
  Feed = 'feed',
  Gallery = 'gallery',
  StickyStory = 'sticky-story',
}
